// src/utils/audioPlayer.js
// Utilitaire pour jouer les fichiers audio arabes
// - Fichiers MP3 ElevenLabs pour dhikr et vocabulaire
// - API Quran.com pour versets coraniques (meilleure qualité)

// Base URL pour les fichiers audio locaux
const AUDIO_BASE_URL = process.env.REACT_APP_API_URL || '';

// Récitateur par défaut pour Quran.com API
const DEFAULT_RECITER_ID = 7; // Mishary Rashid Alafasy

// ==================== VERSETS CORANIQUES (Quran.com API) ====================
const quranVerses = {
  // Basmala (1:1)
  'بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيم': { surah: 1, ayah: 1 },
  'بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ': { surah: 1, ayah: 1 },
  
  // Al-Fatiha complète
  'الْحَمْدُ لِلَّهِ رَبِّ الْعَالَمِينَ ۝ الرَّحْمَٰنِ الرَّحِيمِ ۝ مَالِكِ يَوْمِ الدِّينِ ۝ إِيَّاكَ نَعْبُدُ وَإِيَّاكَ نَسْتَعِينُ ۝ اهْدِنَا الصِّرَاطَ الْمُسْتَقِيمَ ۝ صِرَاطَ الَّذِينَ أَنْعَمْتَ عَلَيْهِمْ غَيْرِ الْمَغْضُوبِ عَلَيْهِمْ وَلَا الضَّالِّينَ': { surah: 1, fullSurah: true },
};

// ==================== MAPPING FICHIERS MP3 (ElevenLabs) ====================
const audioMapping = {
  // ==================== LETTRES ====================
  'أ': '/audio/letters/alif.mp3',
  'أَلِف': '/audio/letters/alif.mp3',
  'ب': '/audio/letters/ba.mp3',
  'بَاء': '/audio/letters/ba.mp3',
  'ت': '/audio/letters/ta.mp3',
  'تَاء': '/audio/letters/ta.mp3',
  'ث': '/audio/letters/tha.mp3',
  'ثَاء': '/audio/letters/tha.mp3',
  'ج': '/audio/letters/jim.mp3',
  'جِيم': '/audio/letters/jim.mp3',
  'ح': '/audio/letters/ha.mp3',
  'حَاء': '/audio/letters/ha.mp3',
  'خ': '/audio/letters/kha.mp3',
  'خَاء': '/audio/letters/kha.mp3',
  'د': '/audio/letters/dal.mp3',
  'دَال': '/audio/letters/dal.mp3',
  'ذ': '/audio/letters/dhal.mp3',
  'ذَال': '/audio/letters/dhal.mp3',
  'ر': '/audio/letters/ra.mp3',
  'رَاء': '/audio/letters/ra.mp3',
  'ز': '/audio/letters/zay.mp3',
  'زَاي': '/audio/letters/zay.mp3',
  'س': '/audio/letters/sin.mp3',
  'سِين': '/audio/letters/sin.mp3',
  'ش': '/audio/letters/shin.mp3',
  'شِين': '/audio/letters/shin.mp3',
  'ص': '/audio/letters/sad.mp3',
  'صَاد': '/audio/letters/sad.mp3',
  'ض': '/audio/letters/dad.mp3',
  'ضَاد': '/audio/letters/dad.mp3',
  'ط': '/audio/letters/ta_emphatic.mp3',
  'طَاء': '/audio/letters/ta_emphatic.mp3',
  'ظ': '/audio/letters/dha_emphatic.mp3',
  'ظَاء': '/audio/letters/dha_emphatic.mp3',
  'ع': '/audio/letters/ayn.mp3',
  'عَيْن': '/audio/letters/ayn.mp3',
  'غ': '/audio/letters/ghayn.mp3',
  'غَيْن': '/audio/letters/ghayn.mp3',
  'ف': '/audio/letters/fa.mp3',
  'فَاء': '/audio/letters/fa.mp3',
  'ق': '/audio/letters/qaf.mp3',
  'قَاف': '/audio/letters/qaf.mp3',
  'ك': '/audio/letters/kaf.mp3',
  'كَاف': '/audio/letters/kaf.mp3',
  'ل': '/audio/letters/lam.mp3',
  'لَام': '/audio/letters/lam.mp3',
  'م': '/audio/letters/mim.mp3',
  'مِيم': '/audio/letters/mim.mp3',
  'ن': '/audio/letters/nun.mp3',
  'نُون': '/audio/letters/nun.mp3',
  'ه': '/audio/letters/ha_light.mp3',
  'هَاء': '/audio/letters/ha_light.mp3',
  'و': '/audio/letters/waw.mp3',
  'وَاو': '/audio/letters/waw.mp3',
  'ي': '/audio/letters/ya.mp3',
  'يَاء': '/audio/letters/ya.mp3',

  // ==================== MOTS EXEMPLES ====================
  'أَسَد': '/audio/words/asad.mp3',
  'أَب': '/audio/words/ab.mp3',
  'بَيْت': '/audio/words/bayt.mp3',
  'بَاب': '/audio/words/bab.mp3',
  'تُفَّاح': '/audio/words/tuffah.mp3',
  'تَمْر': '/audio/words/tamr.mp3',
  'ثَعْلَب': '/audio/words/thalab.mp3',
  'ثَلْج': '/audio/words/thalj.mp3',
  'جَمَل': '/audio/words/jamal.mp3',
  'جَبَل': '/audio/words/jabal.mp3',
  'حَلِيب': '/audio/words/halib.mp3',
  'حُب': '/audio/words/hubb.mp3',
  'خُبْز': '/audio/words/khubz.mp3',
  'خَيْر': '/audio/words/khayr.mp3',
  'دَجَاج': '/audio/words/dajaj.mp3',
  'دُب': '/audio/words/dubb.mp3',
  'ذَهَب': '/audio/words/dhahab.mp3',
  'ذِئْب': '/audio/words/dhib.mp3',
  'رَجُل': '/audio/words/rajul.mp3',
  'رَأْس': '/audio/words/ras.mp3',
  'زَيْتُون': '/audio/words/zaytun.mp3',
  'زَهْرَة': '/audio/words/zahra.mp3',
  'سَمَك': '/audio/words/samak.mp3',
  'سَمَاء': '/audio/words/sama.mp3',
  'شَمْس': '/audio/words/shams.mp3',
  'شَجَرَة': '/audio/words/shajara.mp3',
  'صَبَاح': '/audio/words/sabah.mp3',
  'صَدِيق': '/audio/words/sadiq.mp3',
  'ضَوْء': '/audio/words/daw.mp3',
  'ضِفْدَع': '/audio/words/difda.mp3',
  'طَائِر': '/audio/words/tair.mp3',
  'طَبِيب': '/audio/words/tabib.mp3',
  'ظَهْر': '/audio/words/dhahr.mp3',
  'ظِل': '/audio/words/dhil.mp3',
  'عَسَل': '/audio/words/asal.mp3',
  'غُرَاب': '/audio/words/ghurab.mp3',
  'غَابَة': '/audio/words/ghaba.mp3',
  'فِيل': '/audio/words/fil.mp3',
  'فَرَاشَة': '/audio/words/farasha.mp3',
  'قَمَر': '/audio/words/qamar.mp3',
  'قَلْب': '/audio/words/qalb.mp3',
  'كِتَاب': '/audio/words/kitab.mp3',
  'كَلْب': '/audio/words/kalb.mp3',
  'لَيْمُون': '/audio/words/laymun.mp3',
  'لَيْل': '/audio/words/layl.mp3',
  'مَاء': '/audio/words/ma.mp3',
  'مَدْرَسَة': '/audio/words/madrasa.mp3',
  'نَجْم': '/audio/words/najm.mp3',
  'نَار': '/audio/words/nar.mp3',
  'هِلَال': '/audio/words/hilal.mp3',
  'هَدِيَّة': '/audio/words/hadiyya.mp3',
  'وَرْد': '/audio/words/ward.mp3',
  'وَلَد': '/audio/words/walad.mp3',
  'يَد': '/audio/words/yad.mp3',
  'يَوْم': '/audio/words/yawm.mp3',

  // ==================== PRIÈRES QUOTIDIENNES ====================
  'الفَجْر': '/audio/prayers/fajr.mp3',
  'الظُّهْر': '/audio/prayers/dhuhr.mp3',
  'العَصْر': '/audio/prayers/asr.mp3',
  'المَغْرِب': '/audio/prayers/maghrib.mp3',
  'العِشَاء': '/audio/prayers/isha.mp3',

  // ==================== NOMS DES 5 PILIERS ====================
  'الشَّهَادَة': '/audio/pillars/shahada_name.mp3',
  'الصَّلَاة': '/audio/pillars/salat_name.mp3',
  'الزَّكَاة': '/audio/pillars/zakat_name.mp3',
  'الصَّوْم': '/audio/pillars/sawm_name.mp3',
  'الحَجّ': '/audio/pillars/hajj_name.mp3',

  // ==================== TEXTES DES PILIERS ====================
  'أَشْهَدُ أَنْ لَا إِلَٰهَ إِلَّا اللَّهُ وَأَشْهَدُ أَنَّ مُحَمَّدًا رَسُولُ اللَّهِ': '/audio/pillars/shahada_full.mp3',
  'لَا إِلَٰهَ إِلَّا اللَّهُ': '/audio/pillars/la_ilaha.mp3',
  'مُحَمَّدٌ رَسُولُ اللَّهِ': '/audio/pillars/muhammad_rasul.mp3',

  // ==================== RAMADAN ====================
  'رَمَضَان': '/audio/ramadan/ramadan.mp3',
  'لَيْلَةُ القَدْر': '/audio/ramadan/laylat_qadr.mp3',
  'سُحُور': '/audio/ramadan/suhoor.mp3',
  'إِفْطَار': '/audio/ramadan/iftar.mp3',
  'تَرَاوِيح': '/audio/ramadan/tarawih.mp3',

  // ==================== HAJJ ====================
  'مَكَّة المُكَرَّمَة': '/audio/hajj/makkah.mp3',
  'الكَعْبَة': '/audio/hajj/kaaba.mp3',
  'ذُو الحِجَّة': '/audio/hajj/dhul_hijja.mp3',
  'إِحْرَام': '/audio/hajj/ihram.mp3',
  'طَوَاف': '/audio/hajj/tawaf.mp3',
  'سَعْي': '/audio/hajj/sai.mp3',
  'عَرَفَة': '/audio/hajj/arafat.mp3',
  'رَمْي الجَمَرَات': '/audio/hajj/ramy_jamarat.mp3',
  'عِيد الأَضْحَى': '/audio/hajj/eid_adha.mp3',
  'مُزْدَلِفَة': '/audio/hajj/muzdalifa.mp3',
  'مِنَى': '/audio/hajj/mina.mp3',

  // ==================== WUDU (Ablutions) ====================
  'بِسْمِ اللَّهِ': '/audio/wudu/bismillah.mp3',
  'بِسْمِ اللَّه': '/audio/wudu/bismillah.mp3',
  'النِّيَّة': '/audio/wudu/niyyah.mp3',
  'غَسْل اليَدَيْن': '/audio/wudu/ghasl_yadayn.mp3',
  'المَضْمَضَة': '/audio/wudu/madmada.mp3',
  'الاِسْتِنْشَاق': '/audio/wudu/istinshaq.mp3',
  'غَسْل الوَجْه': '/audio/wudu/ghasl_wajh.mp3',
  'غَسْل اليَدَيْن إِلَى المِرْفَقَيْن': '/audio/wudu/ghasl_yadayn_mirfaq.mp3',
  'مَسْح الرَّأْس': '/audio/wudu/mash_ras.mp3',
  'مَسْح الأُذُنَيْن': '/audio/wudu/mash_udhnayn.mp3',
  'غَسْل الرِّجْلَيْن': '/audio/wudu/ghasl_rijlayn.mp3',
  'الدُّعَاء': '/audio/wudu/dua_wudu.mp3',
  'أَشْهَدُ أَنْ لَا إِلَٰهَ إِلَّا اللَّهُ وَأَشْهَدُ أَنَّ مُحَمَّدًا عَبْدُهُ وَرَسُولُهُ': '/audio/wudu/shahada_wudu.mp3',

  // ==================== POSITIONS DE LA PRIÈRE ====================
  'تَكْبِيرَة الإِحْرَام': '/audio/positions/takbirat_ihram.mp3',
  'القِيَام': '/audio/positions/qiyam.mp3',
  'الاِعْتِدَال': '/audio/positions/itidal.mp3',
  'الرُّكُوع': '/audio/positions/ruku_position.mp3',
  'السُّجُود': '/audio/positions/sujud_position.mp3',
  'الجُلُوس': '/audio/positions/juloos.mp3',
  'الجُلُوس بَيْنَ السَّجْدَتَيْن': '/audio/positions/juloos_bayn.mp3',
  'التَّشَهُّد': '/audio/positions/tashahhud_position.mp3',
  'التَّحِيَّات': '/audio/positions/tahiyyat_name.mp3',
  'الصَّلَاة الإِبْرَاهِيمِيَّة': '/audio/positions/salat_ibrahimiya_name.mp3',
  'التَّسْلِيم': '/audio/positions/taslim_position.mp3',

  // ==================== NOMS DES RÉCITATIONS ====================
  'تَكْبِير': '/audio/recitations/takbir_name.mp3',
  'دُعَاء الاِسْتِفْتَاح': '/audio/recitations/istiftah_name.mp3',
  'التَّعَوُّذ': '/audio/recitations/taawwudh_name.mp3',
  'البَسْمَلَة': '/audio/recitations/basmala_name.mp3',
  'الفَاتِحَة': '/audio/recitations/fatiha_name.mp3',
  'ذِكْر الرُّكُوع': '/audio/recitations/dhikr_ruku_name.mp3',
  'بَعْد الرُّكُوع': '/audio/recitations/baad_ruku_name.mp3',
  'ذِكْر السُّجُود': '/audio/recitations/dhikr_sujud_name.mp3',
  'بَيْنَ السَّجْدَتَيْن': '/audio/recitations/bayn_sajdatayn_name.mp3',

  // ==================== DHIKR / RÉCITATIONS (textes complets) ====================
  'اللَّهُ أَكْبَر': '/audio/prayer/takbir.mp3',
  'سَمِعَ اللَّهُ لِمَنْ حَمِدَهُ': '/audio/prayer/sami_allah.mp3',
  'رَبَّنَا وَلَكَ الحَمْد': '/audio/prayer/rabbana.mp3',
  'سَمِعَ اللَّهُ لِمَنْ حَمِدَهُ - رَبَّنَا وَلَكَ الحَمْد': '/audio/prayer/sami_allah.mp3',
  'سُبْحَانَ رَبِّيَ العَظِيم': '/audio/prayer/subhana_adhim.mp3',
  'سُبْحَانَ رَبِّيَ الأَعْلَى': '/audio/prayer/subhana_ala.mp3',
  'رَبِّ اغْفِرْ لِي': '/audio/prayer/rabbi_ghfir.mp3',
  'السَّلَامُ عَلَيْكُمْ وَرَحْمَةُ اللَّه': '/audio/prayer/taslim.mp3',
  'التَّحِيَّاتُ لِلَّهِ وَالصَّلَوَاتُ وَالطَّيِّبَاتُ، السَّلَامُ عَلَيْكَ أَيُّهَا النَّبِيُّ وَرَحْمَةُ اللَّهِ وَبَرَكَاتُهُ، السَّلَامُ عَلَيْنَا وَعَلَى عِبَادِ اللَّهِ الصَّالِحِينَ، أَشْهَدُ أَنْ لَا إِلَهَ إِلَّا اللَّهُ وَأَشْهَدُ أَنَّ مُحَمَّدًا عَبْدُهُ وَرَسُولُهُ': '/audio/prayer/tahiyyat.mp3',
  'اللَّهُمَّ صَلِّ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا صَلَّيْتَ عَلَى إِبْرَاهِيمَ وَعَلَى آلِ إِبْرَاهِيمَ إِنَّكَ حَمِيدٌ مَجِيدٌ، اللَّهُمَّ بَارِكْ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا بَارَكْتَ عَلَى إِبْرَاهِيمَ وَعَلَى آلِ إِبْرَاهِيمَ إِنَّكَ حَمِيدٌ مَجِيدٌ': '/audio/prayer/salat_ibrahimiya.mp3',
  'سُبْحَانَكَ اللَّهُمَّ وَبِحَمْدِكَ وَتَبَارَكَ اسْمُكَ وَتَعَالَى جَدُّكَ وَلَا إِلَهَ غَيْرُكَ': '/audio/prayer/istiftah.mp3',
  'أَعُوذُ بِاللَّهِ مِنَ الشَّيْطَانِ الرَّجِيم': '/audio/prayer/taawwudh.mp3',
  'آمِين': '/audio/prayer/amin.mp3',
};

// ==================== INSTANCE AUDIO ====================
let currentAudio = null;

// ==================== FONCTIONS QURAN.COM API ====================

/**
 * Récupère l'URL audio d'un verset depuis Quran.com API
 */
async function getQuranAudioUrl(surah, ayah = null, reciterId = DEFAULT_RECITER_ID) {
  try {
    let url;
    if (ayah) {
      url = `https://api.quran.com/api/v4/recitations/${reciterId}/by_ayah/${surah}:${ayah}`;
    } else {
      url = `https://api.quran.com/api/v4/recitations/${reciterId}/by_chapter/${surah}`;
    }
    
    const response = await fetch(url);
    const data = await response.json();
    
    if (data.audio_files && data.audio_files.length > 0) {
      const audioFile = data.audio_files[0];
      return audioFile.url.startsWith('http') 
        ? audioFile.url 
        : `https://verses.quran.com/${audioFile.url}`;
    }
    return null;
  } catch (error) {
    console.error('Erreur Quran.com API:', error);
    return null;
  }
}

/**
 * Joue une sourate complète depuis Quran.com API
 */
async function playQuranSurah(surah, reciterId = DEFAULT_RECITER_ID) {
  try {
    const url = `https://api.quran.com/api/v4/chapter_recitations/${reciterId}/${surah}`;
    const response = await fetch(url);
    const data = await response.json();
    
    if (data.audio_file && data.audio_file.audio_url) {
      stopArabic();
      currentAudio = new Audio(data.audio_file.audio_url);
      currentAudio.play();
      return true;
    }
    return false;
  } catch (error) {
    console.error('Erreur lecture sourate:', error);
    return false;
  }
}

/**
 * Joue un verset spécifique depuis Quran.com API
 */
async function playQuranVerse(surah, ayah, reciterId = DEFAULT_RECITER_ID) {
  try {
    const audioUrl = await getQuranAudioUrl(surah, ayah, reciterId);
    if (audioUrl) {
      stopArabic();
      currentAudio = new Audio(audioUrl);
      currentAudio.play();
      return true;
    }
    return false;
  } catch (error) {
    console.error('Erreur lecture verset:', error);
    return false;
  }
}

// ==================== FONCTION PRINCIPALE ====================

/**
 * Joue un texte arabe
 * - Utilise Quran.com API pour les versets coraniques
 * - Utilise les fichiers MP3 pour le reste
 * - Fallback sur speechSynthesis si nécessaire
 * 
 * @param {string} text - Le texte arabe à prononcer
 * @param {object} options - Options (useFallback: boolean, reciterId: number)
 */
export const playArabic = async (text, options = { useFallback: true, reciterId: DEFAULT_RECITER_ID }) => {
  // Arrêter l'audio en cours
  stopArabic();
  
  // Nettoyer le texte
  const cleanText = text.trim();
  
  // 1. Vérifier si c'est un verset coranique (Quran.com API)
  const quranInfo = quranVerses[cleanText];
  if (quranInfo) {
    console.log('🕌 Lecture via Quran.com API:', quranInfo);
    
    let success = false;
    if (quranInfo.fullSurah) {
      success = await playQuranSurah(quranInfo.surah, options.reciterId);
    } else {
      success = await playQuranVerse(quranInfo.surah, quranInfo.ayah, options.reciterId);
    }
    
    if (success) return;
  }
  
  // 2. Vérifier si un fichier MP3 existe
  const audioPath = audioMapping[cleanText];
  if (audioPath) {
    const fullUrl = `${AUDIO_BASE_URL}${audioPath}`;
    currentAudio = new Audio(fullUrl);
    
    currentAudio.onerror = () => {
      console.warn(`Audio non trouvé: ${fullUrl}, fallback sur speechSynthesis`);
      if (options.useFallback) {
        playWithSpeechSynthesis(cleanText);
      }
    };
    
    currentAudio.play().catch(err => {
      console.warn('Erreur lecture audio:', err);
      if (options.useFallback) {
        playWithSpeechSynthesis(cleanText);
      }
    });
    return;
  }
  
  // 3. Fallback sur speechSynthesis
  console.log(`Pas de source audio pour: "${cleanText.substring(0, 30)}...", utilisation speechSynthesis`);
  if (options.useFallback) {
    playWithSpeechSynthesis(cleanText);
  }
};

/**
 * Fallback sur Web Speech API
 */
const playWithSpeechSynthesis = (text) => {
  if ('speechSynthesis' in window) {
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'ar-SA';
    utterance.rate = 0.7;
    window.speechSynthesis.speak(utterance);
  }
};

/**
 * Arrête la lecture audio en cours
 */
export const stopArabic = () => {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio = null;
  }
  if ('speechSynthesis' in window) {
    window.speechSynthesis.cancel();
  }
};

/**
 * Vérifie si une source audio existe pour ce texte
 */
export const hasAudioFile = (text) => {
  const cleanText = text.trim();
  return !!audioMapping[cleanText] || !!quranVerses[cleanText];
};

/**
 * Joue directement depuis Quran.com API (pour usage externe)
 */
export const playFromQuran = async (surah, ayah = null, reciterId = DEFAULT_RECITER_ID) => {
  stopArabic();
  if (ayah) {
    return await playQuranVerse(surah, ayah, reciterId);
  } else {
    return await playQuranSurah(surah, reciterId);
  }
};

export default { playArabic, stopArabic, hasAudioFile, playFromQuran };
